import {
  Bot,
  Zap,
  Workflow,
  Link2,
  Globe,
  MessageSquare,
  Settings,
  type LucideIcon,
} from 'lucide-react'

// 服务类型配置
export interface ServiceType {
  id: string
  name: string
  displayName: string
  description: string
  icon: LucideIcon // lucide-react 图标
  color: string // Tailwind 颜色类
  bgColor: string // 背景色
  gradient: string // 渐变背景色类
  features?: string[]
}

export const SERVICE_TYPES: ServiceType[] = [
  {
    id: 'coze-bot',
    name: 'coze-bot',
    displayName: 'Coze 智能体',
    description: '基于 Coze 平台的 AI 智能体服务',
    icon: Bot,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    gradient: 'bg-gradient-to-br from-purple-50 via-purple-100 to-fuchsia-50',
    features: ['对话交互', '多轮对话', '知识库', '插件扩展']
  },
  {
    id: 'coze-workflow',
    name: 'coze-workflow',
    displayName: 'Coze 工作流',
    description: 'Coze 平台的自动化工作流服务',
    icon: Zap,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    gradient: 'bg-gradient-to-br from-blue-50 via-cyan-50 to-sky-100',
    features: ['流程自动化', '节点编排', '条件分支', '循环处理']
  },
  {
    id: 'dify-workflow',
    name: 'dify-workflow',
    displayName: 'Dify 工作流',
    description: 'Dify 平台的 LLM 应用工作流',
    icon: Workflow,
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    gradient: 'bg-gradient-to-br from-indigo-50 via-violet-50 to-purple-100',
    features: ['LLM 编排', '数据处理', '工具调用', '变量管理']
  },
  {
    id: 'n8n-workflow',
    name: 'n8n-workflow',
    displayName: 'n8n 工作流',
    description: 'n8n 平台的自动化工作流服务',
    icon: Link2,
    color: 'text-pink-600',
    bgColor: 'bg-pink-50',
    gradient: 'bg-gradient-to-br from-pink-50 via-rose-50 to-red-100',
    features: ['集成自动化', '触发器', 'Webhook', '定时任务']
  },
  {
    id: 'api-service',
    name: 'api-service',
    displayName: 'API 服务',
    description: '通用 REST API 服务接口',
    icon: Globe,
    color: 'text-green-600',
    bgColor: 'bg-green-50',
    gradient: 'bg-gradient-to-br from-green-50 via-emerald-50 to-teal-100',
    features: ['HTTP 请求', '自定义端点', 'RESTful', 'JSON 数据']
  },
  {
    id: 'openai-compatible',
    name: 'openai-compatible',
    displayName: 'OpenAI 兼容',
    description: 'OpenAI API 兼容的大语言模型服务',
    icon: MessageSquare,
    color: 'text-teal-600',
    bgColor: 'bg-teal-50',
    gradient: 'bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-100',
    features: ['Chat Completion', 'Streaming', 'Function Call', '多模型支持']
  },
  {
    id: 'custom',
    name: 'custom',
    displayName: '自定义服务',
    description: '其他自定义或第三方服务',
    icon: Settings,
    color: 'text-gray-600',
    bgColor: 'bg-gray-50',
    gradient: 'bg-gradient-to-br from-gray-50 via-slate-50 to-zinc-100',
    features: ['灵活配置', '自定义参数', '自定义协议']
  }
]

// 根据 ID 获取服务类型
export function getServiceType(id: string): ServiceType | undefined {
  return SERVICE_TYPES.find(type => type.id === id)
}

// 根据 name 获取服务类型
export function getServiceTypeByName(name: string): ServiceType | undefined {
  return SERVICE_TYPES.find(type => type.name === name)
}

// 获取所有服务类型的 ID 列表
export function getAllServiceTypeIds(): string[] {
  return SERVICE_TYPES.map(type => type.id)
}

// 获取所有服务类型的名称列表
export function getAllServiceTypeNames(): string[] {
  return SERVICE_TYPES.map(type => type.name)
}
